import { Grid, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import { SummaryDto } from "../../../../app/models/summary/summaryDto";
import { useAppDispatch, useAppSelector } from "../../../../app/store/configureStore";
import { GetSummaryColorCode } from "../../../../app/utils/util";
import { ApiRequestStatus } from "../../../../app/enums/apiRequestStatus";
import { getCreditSummaryAsync } from "../../../../app/slices/pcsSlice";
import AppInformationText from "../../../../app/components/AppInformationText";

export default function PcsPlanLegacySummaryTable() {
    const { currentYear, legacySummaryData, legacyTitles, getCreditSummaryStatus } = useAppSelector(state => state.pcs);
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (legacySummaryData === null && getCreditSummaryStatus === ApiRequestStatus.Idle) {
            dispatch(getCreditSummaryAsync());
        }
    }, [legacySummaryData, getCreditSummaryStatus, dispatch]);

    const [creditSummarydata, setCreditSummaryData] = useState<SummaryDto[]>([]);
    const [isYearPartialyCompleted, setIsYearPartialyCompleted] = useState<boolean>(false);

    useEffect(() => {
        if (legacySummaryData && currentYear !== null) {
            legacySummaryData.map((item: SummaryDto[]) => {
                if (item[0].text.substring(0, 4) === (currentYear - 1).toString()) {
                    setCreditSummaryData(item);
                }

                let isYearPartialyComplete = false;
                if (item[2].text.toLowerCase() === "true") {
                    if (isYearPartialyComplete === false) {
                        setIsYearPartialyCompleted(true);
                    }
                }
            });
        }
    }, [legacySummaryData, currentYear]);

    const creditSummaryHelpText = () => {
        return <>
            Green - Credits on Target<br></br>
            Yellow - Credits Approaching Target<br></br>
            Red - Credits not on target<br></br>
        </>
    }

    return <div style={{ width: '97%' }}>

        <Box sx={{ minWidth: "100%", display: { xs: 'none', sm: 'block' } }}>
            <Grid container rowSpacing={4} sx={{ paddingTop: "5%" }}>

                <Grid size={{ xs: 6, md: 2, sm: 3 }}>
                    <Typography variant='h5' sx={{ fontWeight: '550' }}>Credit summary</Typography>
                </Grid>

                <Grid size={{ xs: 1, md: 1, sm: 1 }} sx={{ marginTop: '-7px' }}>
                    <AppInformationText information_text={creditSummaryHelpText()} placement={"top"} />
                </Grid>

                <Grid size={{ xs: 5, md: 5, sm: 8 }}></Grid>
            </Grid>
        </Box>

        <Box sx={{ minWidth: "100%", display: { xs: 'none', sm: 'block' } }}>
            <Grid container rowSpacing={4} sx={{ paddingTop: "2%" }} columns={18}>

                <Grid size={{ xs: 6, sm: 2 }} display={{ xs: 'block' }}
                    sx={{ textAlign: 'start', wordBreak: 'break-all' }}>
                    <b>{legacyTitles === null ? '' : legacyTitles[0]}</b>
                </Grid>

                <Grid size={{ sm: 2 }} display={{ xs: 'none', sm: 'block' }} sx={{ textAlign: 'center' }}>
                    <b>{legacyTitles === null ? '' : legacyTitles[2]}</b>
                </Grid>

                <Grid size={{ sm: 2 }} display={{ xs: 'none', sm: 'block' }} sx={{ textAlign: 'center' }}>
                    <b>{legacyTitles === null ? '' : legacyTitles[3]}</b>
                </Grid>

                <Grid size={{ sm: 2 }} display={{ xs: 'none', sm: 'block' }} sx={{ textAlign: 'center' }}>
                    <b>{legacyTitles === null ? '' : legacyTitles[4]}</b>
                </Grid>

                <Grid size={{ sm: 2 }} display={{ xs: 'none', sm: 'block' }} sx={{ textAlign: 'center' }}>
                    <b>{legacyTitles === null ? '' : legacyTitles[5]}</b>
                </Grid>

                <Grid size={{ sm: 2 }} display={{ xs: 'none', sm: 'block' }} sx={{ textAlign: 'center' }}>
                    <b>{legacyTitles === null ? '' : legacyTitles[6]}</b>
                </Grid>

                <Grid size={{ sm: 3 }} display={{ xs: 'none', sm: 'block' }} sx={{ textAlign: 'center' }}>
                    <b>{legacyTitles === null ? '' : legacyTitles[7]}</b>
                </Grid>

                <Grid size={{ xs: 3 }} display={{ xs: 'block', sm: 'none' }}></Grid>

                <Grid size={{ xs: 9, sm: 1.5 }} display={{ xs: 'block' }} sx={{ textAlign: 'center' }}>
                    <b>{legacyTitles === null ? '' : legacyTitles[8]}</b>
                </Grid>

                <Grid size={{ sm: 1.5 }} display={{ xs: 'none', sm: 'block' }} sx={{ textAlign: 'center' }}>
                    <b>{legacyTitles === null ? '' : legacyTitles[9]}</b>
                </Grid>
            </Grid>
        </Box>

        <Box sx={{ minWidth: "100%", display: { xs: 'none', sm: 'block' } }}>
            <Grid container rowSpacing={4} sx={{ paddingTop: "2%" }} columns={18}>
                {creditSummarydata.length > 0 && <>
                    <Grid size={{ xs: 6, sm: 2 }}>
                        <Grid display={{ xs: 'block' }} sx={{ paddingTop: 2, textAlign: 'start' }}>
                            {creditSummarydata[0].text}
                            {isYearPartialyCompleted === true ? "*" : ""}
                        </Grid>
                    </Grid>

                    <Grid size={{ sm: 2 }} display={{ xs: 'none', sm: 'block' }} sx={{ padding: 1 }}>
                        <Grid sx={{
                            backgroundColor: GetSummaryColorCode(creditSummarydata[2].status.toUpperCase()),
                            textAlign: 'center', padding: 1
                        }}><b>{creditSummarydata[2].text.split('(')[0]}</b>({creditSummarydata[2].text.split('(')[1]}</Grid>
                    </Grid>

                    <Grid size={{ sm: 2 }} display={{ xs: 'none', sm: 'block' }} sx={{ padding: 1 }}>
                        <Grid sx={{
                            backgroundColor: GetSummaryColorCode(creditSummarydata[3].status.toUpperCase()),
                            textAlign: 'center', padding: 1
                        }}><b>{creditSummarydata[3].text.split('(')[0]}</b>({creditSummarydata[3].text.split('(')[1]}</Grid>
                    </Grid>

                    <Grid size={{ sm: 2 }} display={{ xs: 'none', sm: 'block' }} sx={{ padding: 1 }}>
                        <Grid sx={{
                            backgroundColor: GetSummaryColorCode(creditSummarydata[4].status.toUpperCase()),
                            textAlign: 'center', padding: 1
                        }}><b>{creditSummarydata[4].text.split('(')[0]}</b>({creditSummarydata[4].text.split('(')[1]}</Grid>
                    </Grid>

                    <Grid size={{ sm: 2 }} display={{ xs: 'none', sm: 'block' }} sx={{ padding: 1 }}>
                        <Grid sx={{
                            backgroundColor: GetSummaryColorCode(creditSummarydata[5].status.toUpperCase()),
                            textAlign: 'center', padding: 1
                        }}><b>{creditSummarydata[5].text.split('(')[0]}</b>({creditSummarydata[5].text.split('(')[1]}</Grid>
                    </Grid>

                    <Grid size={{ sm: 2 }} display={{ xs: 'none', sm: 'block' }} sx={{ padding: 1 }}>
                        <Grid sx={{
                            backgroundColor: GetSummaryColorCode(creditSummarydata[6].status.toUpperCase()),
                            textAlign: 'center', padding: 1
                        }}><b>{creditSummarydata[6].text.split('(')[0]}</b>({creditSummarydata[6].text.split('(')[1]}</Grid>
                    </Grid>

                    <Grid size={{ sm: 3 }} display={{ xs: 'none', sm: 'block' }} sx={{ padding: 1 }}>
                        <Grid sx={{
                            backgroundColor: GetSummaryColorCode(creditSummarydata[7].status.toUpperCase()),
                            textAlign: 'center', padding: 1
                        }}>{creditSummarydata[7].text}</Grid>
                    </Grid>

                    <Grid size={{ xs: 3 }} display={{ xs: 'block', sm: 'none' }}></Grid>

                    <Grid size={{ xs: 9, sm: 1.5 }} display={{ xs: 'block' }} sx={{ padding: 1 }}>
                        <Grid sx={{
                            backgroundColor: GetSummaryColorCode(creditSummarydata[8].status.toUpperCase()),
                            textAlign: 'center', padding: 1
                        }}>{creditSummarydata[8].text}</Grid>
                    </Grid>

                    <Grid size={{ sm: 1.5 }} display={{ xs: 'none', sm: 'block' }}>
                        <Grid sx={{ textAlign: 'center', paddingTop: '16px' }}>{creditSummarydata[9].text}</Grid>
                    </Grid>
                </>}
            </Grid>
        </Box>
    </div >
}
